import Requests from '@/utils/Requests';

const paths = ['requests', 'siteId', 'autoLogin'];
const key = 'vuex';
const loginKey = 'vuex-autoLogin';

const getState = (k) => {
  try {
    const autoLogin = window.localStorage.getItem(loginKey);
    const storage = (autoLogin === 'true') ? window.localStorage : window.sessionStorage;
    const value = storage.getItem(k);
    if (!value || value === 'undefined') {
      return undefined;
    }
    const objValue = JSON.parse(value);
    if ('requests' in objValue) {
      const { accessToken, adminToken } = objValue.requests;
      objValue.requests = new Requests(accessToken, adminToken);
    } else {
      objValue.requests = undefined;
    }
    objValue.autoLogin = JSON.parse(autoLogin);
    return objValue;
  } catch (e) {
    window.console.log(e);
  }
  return undefined;
};

const setState = (k, state) => {
  const { autoLogin } = state;
  window.localStorage.setItem(loginKey, JSON.stringify(autoLogin));
  const storage = autoLogin ? window.localStorage : window.sessionStorage;
  return storage.setItem(k, JSON.stringify(state));
};

const replaceState = (store) => {
  const newState = Object.assign({}, store.state);
  const savedState = getState(key);
  if (typeof savedState === 'object' && savedState) {
    Object.keys(savedState).forEach((k) => {
      newState[k] = savedState[k];
    });
    store.replaceState(newState);
  }
};

export default (store) => {
  replaceState(store);
  window.addEventListener('storage', (e) => {
    if (e.key === key || e.key === loginKey) {
      replaceState(store);
    }
  });

  store.subscribe((mutation, state) => {
    const saveState = {};
    Object.keys(state).forEach((k) => {
      if (paths.includes(k)) {
        saveState[k] = state[k];
      }
    });
    setState(key, saveState);
  });
};



// WEBPACK FOOTER //
// ./src/store/storage.js